import { render, staticRenderFns } from "./PoiView.vue?vue&type=template&id=5d51defd&"
import script from "./PoiView.vue?vue&type=script&lang=js&"
export * from "./PoiView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiView.vue"
export default component.exports